<template>
  <Poptip
    v-model="searchUserPopVisible"
    placement="right"
    @on-popper-show="searchUserShow('search-user')">
    <div v-if="selectedUser" class="user-select">
      {{ selectedUser?.name }}
    </div>
    <div v-else class="user-select" style="font-size: 18px; cursor: pointer;">
      选择业务员
    </div>
    <template slot="content">
      <Row>
        <Input
          ref="search-user"
          placeholder="搜索用户"
          v-model="searchUserText"
          size="small"
          ></Input>
      </Row>
      <div class="user-area">
        <div
          v-for="user in simpleUserList.filter(v => v.name.includes(searchUserText))"
          class="user-card">
          <div v-if="selectedUser?._id === user._id" style="color: blue" @click="selectUser(null)">
            {{ user.name }}
          </div>
          <div v-else @click="selectUser(user)">
            {{ user.name }}
          </div>
        </div>
      </div>
    </template>
  </Poptip>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "TextWithCornerIcon",
  props: ["text", "type", "selectedUser"],
  data() {
    return {
      searchUserPopVisible: false,
      searchUserText: '',
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
      simpleUserList: (state) => state.user.simpleUserList,
    }),
  },
  methods: {
    ...mapActions({
      getUsersList: "user/getSimpleUserListAction",
    }),
    searchUserShow(ref) {
      this.searchUserText = '';
      this.focusRef(ref);
    },
    selectUser(user) {
      this.$emit("selectUser", user)
      this.searchUserPopVisible = false;
    },
    focusRef(ref) {
      this.$nextTick(() => {
        this.$refs[ref].focus({
          cursor: 'end'
        });
      })
    },
  }
};
</script>
<style lang="stylus" scoped>
.user-select
  font-size 18px
  cursor pointer

.user-card
  padding 2px 4px
  cursor pointer
  border-radius 4px
  border 1px solid white
  &:hover
    background-color #f5f7ff

.selected
  border 1px solid blue
</style>